module.exports = __webpack_public_path__ + "static/media/50gogo.255a27b9.mp3";